<tui-input
  tuiTextfieldSize="m"
  [tuiTextfieldCleaner]="true"
  [tuiTextfieldLabelOutside]="true"
  [tuiTextfieldIcon]="'@tui.search'"
  [(ngModel)]="searchQuery"
  (ngModelChange)="onChangeSearchQuery($event)"
>
  {{ 'common.fields.search' | translate }}

  <input tuiTextfieldLegacy type="text" [placeholder]="'common.fields.search' | translate" />
</tui-input>

<ng-container *tuiLet="filteredItems$ | async as items">
  <div class="filter-accordion-content__container">
    <div *ngIf="!items?.length && !searching" class="filter-accordion-content__no-data">
      <span class="tui-text_body-s">
        {{ noDataMessage }}
      </span>
    </div>

    <tui-loader
      *ngIf="searching"
      [size]="'l'"
      [showLoader]="true"
      [inheritColor]="true"
      [overlay]="true"
      class="filter-accordion-content__searching"
    ></tui-loader>

    <ng-container *ngIf="!!items?.length && !searching">
      <select-all-link [mode]="addOrRemoveItemsMode" (clickChange)="onAddOrRemoveItemsToResult()"></select-all-link>

      <tui-scrollbar class="filter-accordion-content__wrapper">
        <div class="filter-accordion-content__wrapper_list">
          <button
            *ngFor="let item of items"
            class="filter-accordion-content__wrapper_item"
            type="button"
            (click)="onToggleItem(item)"
          >
            <input tuiCheckbox type="checkbox" size="m" [checked]="isChecked(item)" />

            <span *ngIf="variant === 'short'" class="tui-text_body-s">{{ item.label }}</span>

            <div *ngIf="variant === 'full' || variant === 'without-avatar'" class="filter-accordion-content__full-view">
              <tui-avatar
                *ngIf="variant === 'full'"
                [src]="item.avatarId | getImageSrc | tuiFallbackSrc: (item.label | tuiInitials) | async"
                [style.background]="!item.avatarId && item.label ? (item.label | tuiAutoColor) : ('' | tuiAutoColor)"
                [size]="'s'"
                [round]="true"
              ></tui-avatar>

              <div class="filter-accordion-content__full-view_row">
                <span class="tui-text_body-s">{{ item.label }}</span>

                <span
                  *tuiLet="item.label !== item.subLabel ? item.subLabel : '' as subLabel"
                  class="tui-text_body-xs"
                  [style.color]="'var(--tui-text-tertiary)'"
                >
                  {{ subLabel }}
                </span>
              </div>
            </div>
          </button>
        </div>
      </tui-scrollbar>
    </ng-container>
  </div>
</ng-container>
